import {
  CV_CNTL_ADVANCE,
  CV_CNTL_CLIPBOARD_SELECT,
  CV_CNTL_COPY,
  CV_CNTL_DELETE_PROBLEM,
  CV_CNTL_DUPLICATE_LINE,
  CV_CNTL_FONT_DECREASE,
  CV_CNTL_FONT_INCREASE,
  CV_CNTL_NEW_GRID_PROBLEM,
  CV_CNTL_NEW_PROBLEM,
  CV_CNTL_NEXT_PROB,
  CV_CNTL_PASTE,
  CV_CNTL_PREV_PROB,
  CV_CNTL_REDO,
  CV_CNTL_UNDO,
  CV_CNTL_ZOOM_IN,
  CV_CNTL_ZOOM_OUT,
  KEY_ID_CROSSOFF_2,
  KEY_ID_DIVISION,
  KEY_ID_EXPONENT,
  KEY_ID_EXPONENT_1,
  KEY_ID_FRACTION,
  KEY_ID_LINE,
  KEY_ID_PI,
  KEY_ID_SQRT,
} from './canvasSymTypes';

export const CTRL_SHORT_CUTS: { [key: string]: string } = {
  KeyM: CV_CNTL_NEW_PROBLEM,
  KeyG: CV_CNTL_NEW_GRID_PROBLEM,
  KeyJ: CV_CNTL_PREV_PROB,
  KeyK: CV_CNTL_NEXT_PROB,
  KeyZ: CV_CNTL_UNDO,
  Equal: CV_CNTL_ZOOM_IN,
  Minus: CV_CNTL_ZOOM_OUT,
  KeyC: CV_CNTL_COPY,
  KeyV: CV_CNTL_PASTE,
  KeyD: CV_CNTL_DUPLICATE_LINE,
  KeyW: CV_CNTL_ADVANCE,
  Backspace: CV_CNTL_DELETE_PROBLEM,
  Comma: CV_CNTL_FONT_DECREASE,
  Period: CV_CNTL_FONT_INCREASE,
  KeyY: CV_CNTL_REDO,
  KeyA: CV_CNTL_CLIPBOARD_SELECT,
};

export const SHORT_CUTS_WITH_EXTRA_ACTIONS: { [key: string]: string } = {
  KeyR: 'KeyR', // Toggle A and AA
  KeyH: 'KeyH', // open help (in  menu)
  KeyF: 'KeyF', // open  new file (in new menu),
  KeyS: 'KeyS', // save file (in  menu)
  //KeyP: 'KeyP', // print file (in  menu)
  KeyO: 'KeyO', // open file (in  menu)
  KeyE: 'KeyE', // export file (in  menu)
  KeyQ: 'KeyQ', /// move to trash (in  menu)
  KeyU: 'KeyU', // Open Profile (in  menu)
  KeyA: 'KeyA', // Open ABC key,
  KeyB: 'KeyB', // Rename file,
  KeyI: 'KeyI', // open import file
};

export const ALT_SHORT_CUTS: { [key: string]: string } = {
  KeyF: KEY_ID_FRACTION,
  KeyR: KEY_ID_SQRT,
  KeyL: KEY_ID_LINE,
  KeyD: KEY_ID_DIVISION,
  KeyE: KEY_ID_EXPONENT,
  KeyS: KEY_ID_EXPONENT_1,
  KeyP: KEY_ID_PI,
  KeyC: KEY_ID_CROSSOFF_2,
};
